import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Dealer} from '../../models/dealers/dealer.model';
import { HttpClient, HttpRequest } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {DealerProduct} from '../../models/dealers/dealer-product.model';
import {AuthService} from '../../auth/auth.service';

@Injectable({providedIn: 'root'})
export class DealerService {
  constructor(private httpClient: HttpClient, private authService: AuthService) {

  }

  dealersByName(name: string): Observable<Array<Dealer>> {
    return this.httpClient.get<Array<Dealer>>(`${environment.baseUrl}/dealersByName/${name}`);
  }

  addDealerProduct(dealerProduct: DealerProduct): Observable<Dealer> {
    return this.httpClient.put<Dealer>(`${environment.baseUrl}/admin/addDealerProduct`, dealerProduct, {headers: this.authService.getHeaders()});
  }

  deleteDealerProduct(dealerProduct: DealerProduct): Observable<any> {
    const request: HttpRequest<DealerProduct> = new HttpRequest('DELETE', `${environment.baseUrl}/admin/deleteDealerProduct`, dealerProduct, {headers: this.authService.getHeaders()});
    return this.httpClient.request(request);
  }

}
